module.exports = __webpack_public_path__ + "static/img/Touchngo.05bcbd01.jpg";